import { Component, OnInit, Inject, ViewChild, ChangeDetectorRef, ElementRef } from '@angular/core';
import { FilterSettingsModel, IFilter, GridComponent, QueryCellInfoEventArgs, DataStateChangeEventArgs, SearchSettingsModel, ToolbarItems, ExcelExportProperties } from '@syncfusion/ej2-angular-grids';
import { Observable, Subject } from 'rxjs';
import { Tooltip } from '@syncfusion/ej2-angular-popups';
import { GlobalComponent } from '../../global/global.component';
import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
// import { ColumnChangeBO, columnWidth } from '../icd10/icd10.model';
import { takeUntil } from 'rxjs/operators';
import * as pbi from "powerbi-client";
import { EnvironmentService } from 'src/app/environment.service';
import { DatePipe } from '@angular/common';
import { DateService } from 'src/app/date.service';
import { IMyDpOptions } from 'mydatepicker';
import { ClaimdashboardBO, exceededhourBO, GetExpiringAuthListBO, GetListBO, GetDashboardHoursDetailsBO, CollapseBo, getEmployeeBO, columnWidth, exportBO } from './dashboard.model';
import { GetComingDueAuthService } from './dashboardauth.service';
import { GetHTTPService } from './dashboardumpi.service';
import { gettimesheetBO } from './dashboard.model';
import { gettimesheet } from '../timesheet/timesheet.model';
import { ClientzipcodeService } from './dashboardclientzipcode.service';
import { CommonApiService } from 'src/app/commonapiservice';
import { DashboardHoursService } from './dashboard.service';
import { log } from 'node:console';
import { EventsServices } from '../events/events.service';
import { GetEventListBo } from '../events/events.modal';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {
  @ViewChild("reportContainer", { static: false }) reportContainer: ElementRef;
  @ViewChild("exceedReportContainer", { static: false }) exceedReportContainer: ElementRef;
  private onDestroy$: Subject<void> = new Subject<void>();
  claimdata: ClaimdashboardBO = new ClaimdashboardBO();
  view: string = 'Total';
  single: any = [];
  referral : any = [];
  HouseStabilizationChart: any = [];
  multi: any = [];
  checkComingDueReport: boolean = false;
  auth: any = [];
  viewHoursChartList: boolean = false;
  inactiveClients: any = [];
  Active87PClaimcount: any = []
  Active87IClaimcount: any = []
  Archeive87PClaimcount: any = []
  Archeive87IClaimcount: any = []
  Active87PClaimAmount: any = []
  Active87IClaimAmount: any = []
  DashboardChartFilterType: any = "CURRENTDATE";
  Archeive87PClaimAmount: any = []
  Archeive87IClaimAmount: any = []
  currentDate: any;
  Hourslabel: string = "";
  AuthDueList: any;
  expandorCollapseall: boolean = false;
  Token: string = "";
  dateType: string = "FromDate";
  locBreak: string = "No";
  reptitle: any = '';
  AuthDataList: any = [];
  InActiveDataList: any = [];
  is30DaysOlderClaimChart: boolean = false;
  isFromorPreparedDateClaimChart: boolean = false;
  gradient: boolean = false;
  colorScheme = {
    domain: ['#689F38', '#0D47A1', '#F47B00', '#0096A6', '#378D3B', '#606060']
  };
  colorScheme1 = {
    domain: ['#0096A6']
  };
  zipCodecolorScheme = {
    domain: ['#689F38', '#0D47A1', '#F47B00', '#0096A6', '#378D3B', '#606060', '#ef1a11', '#530101', '#ca86b0', '#efc760', '#e7a6cb', '#c0d6e4', '#ca86b0']
  };
  getmatchedleie: GetListBO = new GetListBO();
  @ViewChild('gridOig') public gridOig: GridComponent;
  matchedleie: Observable<any>;
  public myDatePickerOptions: IMyDpOptions = {
    dateFormat: 'mm/dd/yyyy',
    editableDateField: true
  };
  public claimsOptions: IMyDpOptions = {
    dateFormat: 'mm/dd/yyyy',
    disableSince: { year: new Date().getFullYear(), month: new Date().getMonth() + 1, day: new Date().getDate() + 1 },
    showClearDateBtn: false,
    editableDateField: true
  };
  Expired30DEndDate: any;
  Expired60DStartDate: any;
  Expired60DEndDate: any;
  Expired90DEndDate: any;
  Expired90DStartDate: any;
  AuthStartDate: any;
  AuthEndDate: any;
  RemainUnit : boolean = false;
  ClientZipCodeData: any = [];
  public data: Observable<DataStateChangeEventArgs>;
  public dataAuth: Observable<DataStateChangeEventArgs>;
  HoursData: any = [];
  public DashboardHoursList: Observable<DataStateChangeEventArgs>;
  public ClientZipCodeList: Observable<DataStateChangeEventArgs>;
  public state: DataStateChangeEventArgs;
  arraycol: any = [];
  ColumnArray: columnWidth[];
  ColumnAuthArray: columnWidth[];
  id: string = "00000000-0000-0000-0000-000000000000";
  ValidationDate: any;
  claimsChartStartDate: any;
  claimsChartEndDate: any;
  CollapseBo: CollapseBo = new CollapseBo();
  // columnchange: ColumnChangeBO = new ColumnChangeBO();
  @ViewChild('grid') public grid: GridComponent;
  @ViewChild('gridAuthList') public gridAuthList: GridComponent;
  @ViewChild('gridUnitList') public gridUnitList: GridComponent;
  @ViewChild('gridClientZipCode') public gridClientZipCode: GridComponent;
  @ViewChild('gridInactiveClientList') public gridInactiveClientList: GridComponent;
  @ViewChild('gridHoursList') public gridHoursList: GridComponent;
  public pageSizes: number[] = [10, 15, 20, 50, 250];
  public submissiondrop: string[];
  public height = '220px';
  public toolbar: ToolbarItems[];
  public searchSettings: SearchSettingsModel;
  filterOptions: FilterSettingsModel;
  filterSettings: FilterSettingsModel;
  initialPage: object;
  ComingDueinitialPage: object;
  ComingDuePage: object
  initialPage1: object;
  initialPageInactiveClients: object;
  DashboardHoursChart: any = [];
  initialPageHours: object;
  initialPageforZipCode: object;
  filter: IFilter;
  ComingDueType: string = "currentpage"
  datalngth: number;
  getInActiveClientBo: gettimesheet = new gettimesheet();
  reportcontain: boolean = false;
  file;
  filename;
  selected: boolean = false;
  configuration: any;
  showdashboardpage: boolean = true;
  ReportstatusList: any = [];
  ClientZipCodeDetailsList: any = [];
  EmployeeDropdown: any = [];
  ExcludedEmployeesList: any = [];
  month: string = (new Date().getMonth() + 1).toString();
  monthList: any = [];
  Oiglist: any = [];
  currentYear: number;
  year: number = new Date().getUTCFullYear();
  curmonth: string = "";
  status: string;
  previousDate: any
  AuthPreviousDate: any;
  Employee: string;
  enableExhours: boolean = true;
  locationId: string = "00000000-0000-0000-0000-000000000000";
  startDate: any;
  endDate: any;
  enableBt: boolean = true;
  public formatOptions: object;
  public formatPhoneNumber: object;
  type: string;
  report = new exceededhourBO();
  empdata: any = []
  ExceededcolorScheme = {
    domain: ['#08DDC1', '#FFDC1B', '#FF5E3A']
  };
  filters: gettimesheetBO = new gettimesheetBO()
  getAuthList: GetExpiringAuthListBO = new GetExpiringAuthListBO();
  GetDashboardHoursFilter = new GetDashboardHoursDetailsBO();
  ClientZipCodeFilter = new getEmployeeBO();
  openexceedchart:boolean=false;
  ExceedChartDateType:string="EXCEEDCURRENTDATE";
  referralAge: any ='false';
  referralStartdate : any = null;
  referralEnddate : any = null;
  referralexport : exportBO = new exportBO();
  referralevent : string;

  public dataevents: Observable<DataStateChangeEventArgs>;
  
  currentPage=1;
  constructor(public CommonAPI: CommonApiService, public toastrService: ToastrService, private router: Router, public http: HttpClient, @Inject(GetHTTPService) public getReport: GetHTTPService, public global: GlobalComponent, public configurationservice: EnvironmentService,
    private datepipe: DatePipe, public dateservice: DateService,
    private cdr: ChangeDetectorRef,
    public ZPService: ClientzipcodeService,
    public UEService: DashboardHoursService,
    @Inject(GetComingDueAuthService) public AuthExpiredList: GetComingDueAuthService,
 public EventService: EventsServices ) {
    this.configuration = this.configurationservice.getEnvironmentsConfiguration();
    this.data = getReport;
    this.dataAuth = AuthExpiredList;
    this.DashboardHoursList = UEService;
    this.ClientZipCodeList = ZPService;
    this.dataevents= CommonAPI;
    this.checkDashboardpremission();
  }
  ngAfterContentChecked() {
    this.cdr.detectChanges();
  }
  checkDashboardpremission() {
    let dashboard = this.global.sideMenuItems.filter(m => m.title == "Dashboard");
    if (dashboard != null) {
      this.showdashboardpage = true;
    }
    else {
      this.showdashboardpage = true;
    }
    // this.getServiceTypes();
  }
  ngOnInit(): void {
    this.collapseCard();
    var today = new Date();
    this.currentDate = this.global.getDateTimeString(today)
    if (this.global.globalAgencyId != null && this.global.globalAgencyId != "00000000-0000-0000-0000-000000000000" && this.global.globalAgencyId != undefined) {
      if (this.global.globalLocationId == null || this.global.globalLocationId == undefined || this.global.globalLocationId == '') {
        this.locationId = "00000000-0000-0000-0000-000000000000";
        // this.getHousingContactTypes();

        // this.getLocation();
      }
      else {
        this.locationId = this.global.globalLocationId;
        // this.getHousingContactTypes();

        // this.getLocation();
      }
    }
    this.toolbar = ['ColumnChooser'];
    this.filterOptions = { type: 'Menu' };
    this.filterSettings = { type: 'Menu' };
    this.ComingDuePage = { currentPage: 1, totalRecordsCount: 0, pageCount: 10, pageSize: this.pageSizes[0], pageSizes: this.pageSizes };
    this.initialPage = { currentPage: 1, totalRecordsCount: 0, pageCount: 10, pageSize: this.pageSizes[0], pageSizes: this.pageSizes };
    this.initialPageforZipCode = { currentPage: 1, totalRecordsCount: 0, pageCount: 10, pageSize: this.pageSizes[0], pageSizes: this.pageSizes };
    // this.getColumnwidth().then((data) => {
    //   let pag = JSON.parse(this.global.globalColumn.column)[0].SuspeciousEmployees.Pagesize;
    //   this.initialPage1 = { currentPage: 1, totalRecordsCount: 0, pageCount: pag, pageSize: pag, pageSizes: this.pageSizes };
    //   let pageHours = JSON.parse(this.global.globalColumn.column)[0].Dashboard_Hours.Pagesize;
    //   this.initialPageHours = { currentPage: 1, totalRecordsCount: 0, pageCount: pageHours, pageSize: pageHours, pageSizes: this.pageSizes };
    //   let pageInactiveClients = JSON.parse(this.global.globalColumn.column)[0].InActiveClients.Pagesize;
    //   this.initialPageInactiveClients = { currentPage: 1, totalRecordsCount: 0, pageCount: pageInactiveClients, pageSize: pageInactiveClients, pageSizes: this.pageSizes };
    //   this.getInActiveClientBo.pageitems = pageInactiveClients;
    //   this.getmatchedleie.currentpageno = 1;
    //   this.getmatchedleie.pageitem = pag;
    //   this.getOIGAnalysis();
    //   this.getmatchedLeie();
    // })
    this.referralAge='false';
    this.formatOptions = { type: 'date', format: 'MM/dd/yyyy' };
  }
  // ...................................expand...................................
  expand() {
    if (this.CollapseBo.EXPBOOL == false) {
      this.CollapseBo.EXPBOOL = true;
    } else if (this.CollapseBo.EXPBOOL == true) {
      this.CollapseBo.EXPBOOL = false;
      this.filters.clientstatus = "Expired SA";
      this.DashboardChartFilterType = "CURRENTDATE";
      this.getAuthCount();



    }
  }
  // Open ExceedAuth Report Dashboard
  expandExceed() {    
    if (this.CollapseBo.EXPBOOLEXCEED == false) {
      this.CollapseBo.EXPBOOLEXCEED = true;
      this.openexceedchart=false;
    } else if (this.CollapseBo.EXPBOOLEXCEED == true) {
      this.CollapseBo.EXPBOOLEXCEED = false;
      this.openexceedchart=false;
      setTimeout(() => {
        this.ShowExceedAuthLineChart();  
      }, 500);
    }
  }
  //................................... expand1...................................
  expand1() {
    if (this.CollapseBo.EXPBOOL1 == false) {
      this.CollapseBo.EXPBOOL1 = true;
    } else if (this.CollapseBo.EXPBOOL1 == true) {
      this.CollapseBo.EXPBOOL1 = false;
      this.getUMPI();
    }
  }
  expandHousingorDashboardHours() {
    if (this.CollapseBo.viewHousingorHoursChart == false) {
      this.CollapseBo.viewHousingorHoursChart = true;
    } else if (this.CollapseBo.viewHousingorHoursChart == true) {
      this.CollapseBo.viewHousingorHoursChart = false;
      this.GetHousingCaseNoteDashboardDetails();
      this.getDashboardHours()
    }
  }
  // ...................................expand2...................................
  expand2() {
    if (this.CollapseBo.EXPBOOL2 == false) {
      this.CollapseBo.EXPBOOL2 = true;
    } else if (this.CollapseBo.EXPBOOL2 == true) {
      this.CollapseBo.EXPBOOL2 = false;
      this.getExpiringAuthorizationCount();
    }
  }
  // ...................................onSelectExp...................................
  public onSelectExp(event) {
    let val: string = event.label
    this.global.reporttype = event.label;

    if (this.global.reporttype == 'Expired') {
      this.filters.clientstatus = 'Expired SA';
      this.exportAsExcelClient();
    }
    else
      if (this.global.reporttype == 'Exceeded') {
        this.filters.clientstatus = 'Exceeded SA Limit';
        this.exportAsExcelClient();
      }
      else
        if (this.global.reporttype == 'Under') {
          this.filters.clientstatus = 'Under SA Limit';
          this.exportAsExcelClient();
        }
  }
  public referralExport(event){
    let val: string = event.label
   this.referralevent = val;
    // this.exportAsExcelReferral();
    this.global.dashtoreferral = true;
    this.global.referralStartdate = this.referralStartdate;
    this.global.referralEnddate = this.referralEnddate;
    this.global.referralStatus = this.referralevent;
    this.global.referralAge = this.referralAge;
    this.router.navigateByUrl("/referral");
  }
  // ...................................onSelect1...................................
  public onSelect1(event) {
    this.router.navigateByUrl("/employee");
  }

  //.....................................onActionComplete.....................................
  public onActionComplete(args) {
    this.report.currentpageno = this.grid.pagerModule.pagerObj.currentPage;
    this.report.pageitem = this.grid.pagerModule.pagerObj.pageSize;
    if (args.name == "actionBegin" && args.requestType == "filterbeforeopen") {
      this.report.type = args.columnType
    }
  }

  //. ..........................................headerCellInfo ..........................................
  headerCellInfo(args) {
    const toolcontent = args.cell.column.headerText;
    const tooltip: Tooltip = new Tooltip({
      content: toolcontent
    });
    tooltip.appendTo(args.node);
  }
  //  ...........................................tooltip..........................................
  tooltip(args: QueryCellInfoEventArgs) {
    if (args.column.field != null) {
      if (args.data[args.column.field] != null) {
        const tooltip: Tooltip = new Tooltip({
          content: args.data[args.column.field].toString(),
          position: 'RightCenter',
        }, args.cell as HTMLTableCellElement);
      }

    }
  }
  // ...........................................getLocation ...........................................
  // getLocation() {
  //   let url = "api/LOV/getLovDropDown?"
  //   let params = new URLSearchParams();
  //   params.append("ListCode", "LOCATION_STATUS");
  //   this.CommonAPI.getDropDownList('LOCATION_STATUS', params, url, "LovDropDown").then((data: any) => {
  //     this.global.globalLocationDropDown = [];
  //     this.global.globalLocationDropDown = data;
  //     this.global.ngLocationDropDown = this.global.globalLocationDropDown;
  //     this.global.ngLocationDropDown.forEach(a => a.Key = a.Key.toString());
  //     this.global.locationData = JSON.parse(localStorage.getItem("ac_locationId"));
  //     this.global.globalLocationId = this.global.locationData;
  //   })
  // }

  // ...........................................getAuthCount ...........................................

  public getAuthCount() {
    // let url = "api/Client/getCount?";
    let url = "api/Client/getAuthCountOptimized";
    let params = new URLSearchParams();
    this.filters.locationLid = (this.global.globalLocationId != null && this.global.globalLocationId != undefined) ? this.global.globalLocationId : "00000000-0000-0000-0000-000000000000"
    let getBO = JSON.parse(JSON.stringify(this.filters));
    getBO.dateFilterType = this.DashboardChartFilterType;
    // params.append("locationId", this.locationId.toString());
    this.http.post(url, getBO).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      if (data != null) {
        // this.fp = data;
        this.single = [
          {
            name: 'Expired',
            value: Math.floor(Number(data.expiredcount))
          },
          {
            name: 'Exceeded',
            value: Math.floor(Number(data.exceedcount))
          },
          {
            name: 'Under',
            value: Math.floor(Number(data.undercount))
          }
        ];
      }
    },
      (err: HttpErrorResponse) => {
        if (err) {
          //  this.toastrService.error('Error in getting authorization data', 'Error'), 8000;
        }
      })
  }
  //  ...........................................showViewEmp ...........................................
  showViewEmp() {
    this.grid.columnChooserModule.openColumnChooser(200, 50);
  }
  // ........................................... showAuth ...........................................
  showAuth() {

    this.gridAuthList.columnChooserModule.openColumnChooser(200, 50);
  }
  // ...........................................dataStateChange ...........................................
  public dataStateChange(state): void {
    this.type = (state.action.requestType).toString();
    if (this.type != "filterchoicerequest") {
      if ((state.sorted || []).length) {
        this.report.orderColumn = state.sorted[0].name;
        this.report.orderType = state.sorted[0].direction === 'descending' ? 'DESC' : 'ASC';
      }
    }
    if (this.type == "filtering" && state.action.action != "clearFilter") {
      if (this.report.type == "number") {
        this.report.value = state.action.currentFilterObject.value.toString();
        this.report.field = state.action.currentFilterObject.field;
      }
      if (this.report.type == "date") {
        this.report.value = (new Date(new Date(state.action.currentFilterObject.value).toLocaleDateString() + " " + "00:00:00" + " " + "GMT").toISOString()).replace("Z", "");
        this.report.field = state.action.currentFilterObject.field;
      }
      else {
        this.report.value = state.action.currentFilterObject.value;
        this.report.field = state.action.currentFilterObject.field;
      }
      this.report.matchCase = state.action.currentFilterObject.matchCase;
      this.report.operator = state.action.currentFilterObject.operator;
    }
    else {
      if (this.type == "filtering" && state.action.action == "clearFilter") {
        this.report.field = "Name";
        this.report.matchCase = false;
        this.report.operator = "contains";
        this.report.value = "";
        this.report.type = "string"
      }
    }
    // this.getUMPI();
  }
  // ...........................................getUMPI...........................................
  getUMPI() {
    this.status = "20";
    if (this.Employee != null || this.Employee != undefined) {
      this.report.employeeId =this.Employee.toString()
    }
    if ((this.year == null || this.year == undefined) && (this.month == null || this.month == undefined)) {
      this.report.startDate = null;
    }
    else {
      if (this.year == null || this.year == undefined) {
        this.year = new Date().getFullYear();
      }
      if (this.month == null || this.month == undefined) {
        this.month = (new Date().getMonth() + 1).toString();
      }
      this.report.startDate = (new Date(new Date(this.year, parseInt(this.month) - 1, 1).toLocaleDateString() + " " + "00:00:00" + " " + "GMT").toISOString()).replace("Z", "")
    }
    this.report.locationId = this.locationId;
    this.getReport.outputValues(this.report);
    this.data.pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.datalngth = data.count;
      this.empdata = data.result;
      this.multi = [
        {
          name: 'Pending UMPI',
          value: Math.floor(Number(data.count))
        },
      ];
      if (data.result.length > 15) {
        this.grid.height = "500";
      } else {
        this.grid.height = "auto";
      }
      this.grid.showColumns(['Month', 'Exceeded Hrs', 'Total Hrs']);
    })
  }
  //...........................................Refresh...........................................
  Refresh() {
    this.report.matchCase = false;
    this.report.operator = "startswith";
    this.report.value = "";
    this.report.type = "string"
    this.report.field = "Name"
    this.report.pageitem = 10;
    this.report.currentpageno = 1;
    this.month = (new Date().getMonth() + 1).toString();
    this.year = new Date().getFullYear();
    this.Employee = "0";
    this.status = "20";
    this.enableExhours = false;
    // this.getUMPI();
  }
  //........................................... getOIGAnalysis...........................................
  getOIGAnalysis() {
    this.UEService.getOIGAnalysis().pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.Oiglist = data;
      // this.getColumnwidthLEIE();
    });
  }
  //........................................... getColumnwidth...........................................
  // getColumnwidth() {
  //   return new Promise((resolve, reject) => {
  //     let url = "api/ColumnChange/getwidth?";
  //     this.CommonAPI.GetFunctionwithResponseTypeJson("", url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
  //       this.global.globalColumn = data;
  //       resolve(data);
  //     },
  //       (err: HttpErrorResponse) => {
  //         reject(err)
  //       })
  //   })
  // }
  //........................................... gotoempDetails...........................................
  gotoempDetails(event) {
    setTimeout(() => {
      let val = this.grid.selectedRowIndex;
      if (val != -1) {
        let val1 = this.empdata[val];
        this.global.globalemployee = val1.id
        this.global.globalemployeedata = val1;
        this.router.navigateByUrl("/employee");
      }
    }, 200);
  }
  //........................................... onFileChanged...........................................
  async onFileChanged(event) {
    let val = await this.tobase64(event.target.files[0]);
    this.file = val;
    this.filename = event.target.files[0].name;
  }
  // ...........................................tobase64...........................................
  tobase64 = value => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(value);
    reader.onload = (e: any) => resolve(e.target.result);
    reader.onerror = error => reject(error);
  });
  // ...........................................onActionCompleteOIG...........................................
  onActionCompleteOIG(args) {
    this.getmatchedleie.currentpageno = this.gridOig.pagerModule.pagerObj.currentPage;
    this.getmatchedleie.pageitem = this.gridOig.pagerModule.pagerObj.pageSize;
    if (args.name == "actionBegin" && args.requestType == "filterbeforeopen") {
      this.getmatchedleie.type = args.columnType;
    }
  }
  // ...........................................dataStateChangeOIG...........................................
  dataStateChangeOIG(state) {
    let type = (state.action.requestType).toString();
    if (type != "filterchoicerequest") {
      if ((state.sorted || []).length) {
        this.getmatchedleie.orderColumn = state.sorted[0].name;
        this.getmatchedleie.orderType = state.sorted[0].direction === 'descending' ? 'DESC' : 'ASC';
      }
    }
    if (type == "filtering" && state.action.action != "clearFilter") {
      if (this.getmatchedleie.type == "number") {
        this.getmatchedleie.value = state.action.currentFilterObject.value.toString();
        this.getmatchedleie.field = state.action.currentFilterObject.field;
      }
      if (this.getmatchedleie.type == "date") {
        this.getmatchedleie.value = (new Date(new Date(state.action.currentFilterObject.value).toLocaleDateString() + " " + "00:00:00" + " " + "GMT").toISOString()).replace("Z", "");
        this.getmatchedleie.field = state.action.currentFilterObject.field;
      }
      else {
        this.getmatchedleie.value = state.action.currentFilterObject.value.toString();
        this.getmatchedleie.field = state.action.currentFilterObject.field;
      }
      this.getmatchedleie.matchCase = state.action.currentFilterObject.matchCase;
      this.getmatchedleie.operator = state.action.currentFilterObject.operator;

    }
    else {
      if (type == "filtering" && state.action.action == "clearFilter") {
        this.getmatchedleie.field = "id";
        this.getmatchedleie.matchCase = false;
        this.getmatchedleie.operator = "greaterthanorequal";
        this.getmatchedleie.value = "00000000-0000-0000-0000-000000000000";
        this.getmatchedleie.type = "number"
      }
    }
    this.getmatchedLeie();
    if (type == "paging" && state.action.name == "actionBegin") {
      if (this.arraycol.length != 0) {
        if (this.arraycol[0].SuspeciousEmployees.Pagesize != state.take) {
          this.arraycol[0].SuspeciousEmployees.Pagesize = state.take
          // this.SaveColumnwidth();
          // }
        }
      }
    }
  }
  //........................................... getmatchedLeie...........................................
  getmatchedLeie() {
    let val = 0;
    this.getmatchedleie.locationId = this.locationId;
    this.UEService.getmatchedLeie(this.getmatchedleie).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      val++;
      this.Oiglist = data;
      this.matchedleie = data;
      this.ExcludedEmployeesList = data.count;
      if (data != null && data != undefined && val == 1) {
        // this.getColumnwidth();
      }
    }
    );
  }
  // ...........................................openOig...........................................
  openOig() {
    this.router.navigateByUrl("/oig");
  }
  //........................................... getColumnwidthLEIE...........................................
  // getColumnwidthLEIE() {
  //   let url = "api/ColumnChange/getwidth?";
  //   this.CommonAPI.GetFunctionwithResponseTypeJson("", url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
  //     if (data != null && data != undefined) {
  //       this.global.globalColumn = data;
  //     }
  //     this.arraycol = JSON.parse(data.column);
  //     console.log(this.arraycol, "Columnjson")
  //     this.ColumnArray = JSON.parse(data.column)[0].SuspeciousEmployees.Columns;
  //     let showcol = JSON.parse(data.column)[0].SuspeciousEmployees.ShowColumns;
  //     //this.grid.showColumns(showcol);log
  //     if (data.userid != null && data.agencyId != null) {
  //       this.id = data.id;
  //     }
  //     if (this.global.globalAgencyId != 0) {
  //       this.gridHoursList.pageSettings.pageSize = JSON.parse(data.column)[0].Dashboard_Hours.Pagesize;
  //     }
  //   });
  // }
  // ...........................................onResize...........................................
  onResize(args) {
    if (this.ColumnArray != undefined && this.ColumnArray != null) {
      const column = this.gridOig.getColumnByField(args.column.field);
      column.width = args.column.width;
      this.ColumnArray.forEach(element => {
        if (element.column == column.headerText) {
          element.width = parseInt(column.width.toString());
        }
      });
      // this.SaveColumnwidth();
    }
  }
  // ...........................................SaveColumnwidth...........................................
  // SaveColumnwidth() {
  //   this.arraycol[0].SuspeciousEmployees.Columns = this.ColumnArray;
  //   this.arraycol[0].Dashboard_Hours.Pagesize = this.gridHoursList.pageSettings.pageSize;
  //   this.arraycol[0].SuspeciousEmployees.Pagesize = this.gridOig.pageSettings.pageSize;
  //   this.columnchange.userid = parseInt(this.global.userID);
  //   this.columnchange.column = JSON.stringify(this.arraycol);
  //   this.columnchange.id = this.id;
  //   let url = "api/ColumnChange/Savewidth?";
  //   this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(this.columnchange, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
  //     // this.getColumnwidthLEIE();
  //   });
  // }
  //........................................... getActive837PClaimDashboard...........................................
  getActive837PClaimDashboard() {
    this.minusto30days();
    this.claimdata.DateFilterType = this.isFromorPreparedDateClaimChart;
    this.claimdata.filterType = this.is30DaysOlderClaimChart;
    this.claimdata.locationId = this.locationId;
    this.claimdata.is837I = false;
    this.claimdata.claimStatus = "ACTIVE";
    let url = "api/ClaimMaster/GetClaimdashboard?";
    this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(this.claimdata, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      if (data != null) {
        this.Active87PClaimcount = [
          {
            name: 'Fully Paid',
            value: Math.floor(Number(data.paidtotal))
          },
          {
            name: 'Partially Paid',
            value: Math.floor(Number(data.partialypaidtotal))
          },
          {
            name: 'Denied',
            value: Math.floor(Number(data.deniedtotal))
          },
          {
            name: 'Progess',
            value: Math.floor(Number(data.progresstotal))
          },
          {
            name: 'Patient Responsibility',
            value: Math.floor(Number(data.patientResptotal))
          }
        ];
        this.Active87PClaimAmount = [
          {
            name: 'Fully Paid',
            value: (Math.floor(Number(data.paidAmout)))
          },
          {
            name: 'Partially Paid',
            value: Math.floor(Number(data.partialypaidAmount))
          },
          {
            name: 'Denied',
            value: Math.floor(Number(data.deniedAmout))
          },
          {
            name: 'Progess',
            value: Math.floor(Number(data.progressAmount))
          },
          {
            name: 'Patient Responsibility',
            value: Math.floor(Number(data.patientRespAmount))
          }
        ];
      }
    },
      (err: HttpErrorResponse) => {
        if (err) {
          //  this.toastrService.error('Error in getting authorization data', 'Error'), 8000;
        }
      })
  }
  // ...........................................getActive837IClaimDashboard...........................................
  getActive837IClaimDashboard() {
    this.minusto30days();
    this.claimdata.DateFilterType = this.isFromorPreparedDateClaimChart;
    this.claimdata.filterType = this.is30DaysOlderClaimChart;
    this.claimdata.locationId = this.locationId;
    this.claimdata.is837I = true;
    this.claimdata.claimStatus = "ACTIVE";
    let url = "api/ClaimMaster/GetClaimdashboard?";
    this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(this.claimdata, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      if (data != null) {
        this.Active87IClaimcount = [
          {
            name: 'Fully Paid',
            value: Math.floor(Number(data.paidtotal))
          },
          {
            name: 'Partially Paid',
            value: Math.floor(Number(data.partialypaidtotal))
          },
          {
            name: 'Denied',
            value: Math.floor(Number(data.deniedtotal))
          },
          {
            name: 'Progess',
            value: Math.floor(Number(data.progresstotal))
          },
          {
            name: 'Patient Responsibility',
            value: Math.floor(Number(data.patientResptotal))
          }
        ];
        this.Active87IClaimAmount = [
          {
            name: 'Fully Paid',
            value: (Math.floor(Number(data.paidAmout)))
          },
          {
            name: 'Partially Paid',
            value: Math.floor(Number(data.partialypaidAmount))
          },
          {
            name: 'Denied',
            value: Math.floor(Number(data.deniedAmout))
          },
          {
            name: 'Progess',
            value: Math.floor(Number(data.progressAmount))
          },
          {
            name: 'Patient Responsibility',
            value: Math.floor(Number(data.patientRespAmount))
          }
        ];
      }

    },
      (err: HttpErrorResponse) => {
        if (err) {
          //  this.toastrService.error('Error in getting authorization data', 'Error'), 8000;
        }
      })
  }
  // ...........................................getArchive837PClaimDashboard...........................................
  getArchive837PClaimDashboard() {
    this.minusto30days();
    this.claimdata.DateFilterType = this.isFromorPreparedDateClaimChart;
    this.claimdata.filterType = this.is30DaysOlderClaimChart;
    this.claimdata.locationId = this.locationId;
    this.claimdata.is837I = false;
    this.claimdata.claimStatus = "ARCHIVE";
    let url = "api/ClaimMaster/GetClaimdashboard?";
    this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(this.claimdata, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      if (data != null) {
        this.Archeive87PClaimcount = [
          {
            name: 'Fully Paid',
            value: Math.floor(Number(data.paidtotal))
          },
          {
            name: 'Partially Paid',
            value: Math.floor(Number(data.partialypaidtotal))
          },
          {
            name: 'Denied',
            value: Math.floor(Number(data.deniedtotal))
          },
          {
            name: 'Progess',
            value: Math.floor(Number(data.progresstotal))
          },
          {
            name: 'Patient Responsibility',
            value: Math.floor(Number(data.patientResptotal))
          }
        ];
        this.Archeive87PClaimAmount = [
          {
            name: 'Fully Paid',
            value: (Math.floor(Number(data.paidAmout)))
          },
          {
            name: 'Partially Paid',
            value: Math.floor(Number(data.partialypaidAmount))
          },
          {
            name: 'Denied',
            value: Math.floor(Number(data.deniedAmout))
          },
          {
            name: 'Progess',
            value: Math.floor(Number(data.progressAmount))
          },
          {
            name: 'Patient Responsibility',
            value: Math.floor(Number(data.patientRespAmount))
          }
        ];
      }
    },
      (err: HttpErrorResponse) => {
        if (err) {
          //  this.toastrService.error('Error in getting authorization data', 'Error'), 8000;
        }
      })
  }
  // ...........................................getArchive837IClaimDashboard...........................................
  getArchive837IClaimDashboard() {
    this.minusto30days();
    this.claimdata.DateFilterType = this.isFromorPreparedDateClaimChart;
    this.claimdata.filterType = this.is30DaysOlderClaimChart;
    this.claimdata.locationId = this.locationId;
    this.claimdata.is837I = true;
    this.claimdata.claimStatus = "ARCHIVE";
    let url = "api/ClaimMaster/GetClaimdashboard?";
    this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(this.claimdata, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      if (data != null) {
        this.Archeive87IClaimcount = [
          {
            name: 'Fully Paid',
            value: Math.floor(Number(data.paidtotal))
          },
          {
            name: 'Partially Paid',
            value: Math.floor(Number(data.partialypaidtotal))
          },
          {
            name: 'Denied',
            value: Math.floor(Number(data.deniedtotal))
          },
          {
            name: 'Progess',
            value: Math.floor(Number(data.progresstotal))
          },
          {
            name: 'Patient Responsibility',
            value: Math.floor(Number(data.patientResptotal))
          }
        ];
        this.Archeive87IClaimAmount = [
          {
            name: 'Fully Paid',
            value: (Math.floor(Number(data.paidAmout)))
          },
          {
            name: 'Partially Paid',
            value: Math.floor(Number(data.partialypaidAmount))
          },
          {
            name: 'Denied',
            value: Math.floor(Number(data.deniedAmout))
          },
          {
            name: 'Progess',
            value: Math.floor(Number(data.progressAmount))
          },
          {
            name: 'Patient Responsibility',
            value: Math.floor(Number(data.patientRespAmount))
          }
        ];
      }

    },
      (err: HttpErrorResponse) => {
        if (err) {
          //  this.toastrService.error('Error in getting authorization data', 'Error'), 8000;
        }
      })
  }
  //........................................... newfunc...........................................
  newfunc(data: number) {
    return data.toString() + "$"
  }
  // ...........................................expand3...........................................
  expand3() {
    this.is30DaysOlderClaimChart = false;
    this.isFromorPreparedDateClaimChart = false;
    if (this.CollapseBo.EXPBOOL3 == false) {
      this.CollapseBo.EXPBOOL3 = true;
    } else if (this.CollapseBo.EXPBOOL3 == true) {
      this.CollapseBo.EXPBOOL3 = false;
      let now = new Date();
      let claimsChartStartDate = new Date(now.setMonth(0, 1));
      this.claimsChartStartDate = this.datepipe.transform(claimsChartStartDate, "MM/dd/yyyy");
      this.claimsChartEndDate = (new Date().getMonth() + 1) + '/' + new Date().getDate() + '/' + new Date().getFullYear();
      this.claimsChartFilter();
      this.claimsAmountChartFilter();


    }

  }
  //........................................... expand4...........................................
  expand4() {
    if (this.CollapseBo.EXPBOOL4 == false) {
      this.CollapseBo.EXPBOOL4 = true;
    } else if (this.CollapseBo.EXPBOOL4 == true) {
      this.CollapseBo.EXPBOOL4 = false;
      let now = new Date();

      this.GetEventsList();
      // let claimsChartStartDate = new Date(now.setMonth(0, 1));
      // this.claimsChartStartDate = this.datepipe.transform(claimsChartStartDate, "MM/dd/yyyy");
      // this.claimsChartEndDate = (new Date().getMonth() + 1) + '/' + new Date().getDate() + '/' + new Date().getFullYear();
      // this.claimsAmountChartFilter();
    }
  }
  expand5() {
    if (this.CollapseBo.EXPBOOL5 == false) {
      this.CollapseBo.EXPBOOL5 = true;
    } else if (this.CollapseBo.EXPBOOL5 == true) {
      this.CollapseBo.EXPBOOL5 = false;
      // let now = new Date();
      // let referalstartdate = new Date(now.setMonth(0, 1));
      // this.referralStartdate = this.datepipe.transform(referalstartdate, "MM/dd/yyyy");
      // this.referralEnddate =  (new Date().getMonth() + 1) + '/' + new Date().getDate() + '/' + new Date().getFullYear();
      this.referralAge = 'false';
      this.getclientcount();
    }
  }
  claimsChartFilter() {
    this.claimdata.fromDate = this.global.getDateTimeString(this.claimsChartStartDate);
    this.claimdata.toDate = this.global.getDateTimeString(this.claimsChartEndDate);
    this.getActive837PClaimDashboard();
    this.getActive837IClaimDashboard();
    this.getArchive837PClaimDashboard();
    this.getArchive837IClaimDashboard();
  }
  claimsAmountChartFilter() {
    this.claimdata.fromDate = this.global.getDateTimeString(this.claimsChartStartDate);
    this.claimdata.toDate = this.global.getDateTimeString(this.claimsChartEndDate);
    this.getActive837PClaimDashboard();
    this.getActive837IClaimDashboard();
    this.getArchive837PClaimDashboard();
    this.getArchive837IClaimDashboard();
  }
  // ...........................................expandcomingdueAuth...........................................
  expandcomingdueAuth() {
    this.CollapseBo.ComingDueBool = !this.CollapseBo.ComingDueBool;
  }
  // ...........................................expandExcludedAuth...........................................
  expandExcludedAuth() {
    this.CollapseBo.Excludedbool = !this.CollapseBo.Excludedbool;
  }
  // ...........................................claimselect...........................................
  claimselect(event, status, is837I: boolean) {
    if (event.label == "Fully Paid") {
      this.global.globalclaimfilter = "Paid"
    }
    else if (event.label == 'Partially Paid') {
      this.global.globalclaimfilter = "PP"
    }
    else if (event.label == 'Denied') {
      this.global.globalclaimfilter = "DENIED"
    }
    else if (event.label == 'Patient Responsibility') {
      this.global.globalclaimfilter = "Patient Responsibility"
    }
    else {
      this.global.globalclaimfilter = "Submit"
    }
    this.global.globalClaimType = is837I;
    this.global.globalCLaimStatus = status;
    this.global.isglobalFromorPreparedDate = this.isFromorPreparedDateClaimChart;
    this.global.isglobal30DaysOlder = this.is30DaysOlderClaimChart;
    this.global.isCheckOperationDashboardRecord = true;
    this.global.claimsFromDate = this.claimsChartStartDate;
    this.global.claimsToDate = this.claimsChartEndDate;
    this.global.isglobal30DaysOlder = this.is30DaysOlderClaimChart
    if (this.is30DaysOlderClaimChart == true) {
      this.global.claimsFromDate = "";
      let toDate: any;
      toDate = new Date(new Date().setDate(new Date().getDate() - 30));
      this.global.claimsToDate = this.global.getDateTimeString(toDate);
    }
    this.router.navigateByUrl("/claims");
  }
  // ............................................closemodal............................................
  closemodal() {
    document.getElementById("openPowerBiModal").click();
    this.reportcontain = false;
  }
  //............................................ getExpiringAuthorizationCount............................................
  getExpiringAuthorizationCount() {
    let params = new URLSearchParams();
    params.append("currentDate", this.currentDate);
    params.append("LocationId", this.locationId?.toString());
    let url = "api/ClientAuthorization/getExpiringAuthorizationCount?";
    this.CommonAPI.GetFunctionwithResponseTypeJson(params, url).pipe(takeUntil(this.onDestroy$)).subscribe((data) => {
      if (data != null) {
        this.auth = [
          {
            name: 'Expired',
            value: Math.floor(Number(data.expired))
          },
          {
            name: 'Expiring within 30 days',
            value: Math.floor(Number(data._1to30Days))
          },
          {
            name: 'Expiring within 60 days',
            value: Math.floor(Number(data._31to60Days))
          },
          {
            name: 'Expiring within 90 days',
            value: Math.floor(Number(data._61to90Days))
          },
          {
            name: 'Low Units',
            value: Math.floor(Number(data.lowRemainingUnits))
          }
        ];
      }
    })
  }
  // ............................................DateAuthChanges............................................
  DateAuthChanges(event, type, name) {
    if (type == "inputchanged") {
      if (name == 'FromDate') {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.AuthStartDate = val1;
        }
      }
      if (name == 'EndDate') {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.AuthEndDate = val1;
        }
      }
      if (name == 'claimsChartStartDate') {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.claimsChartStartDate = val1;
        }
      }
      if (name == 'claimsChartEndDate') {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.claimsChartEndDate = val1;
        }
      }
      if (name == 'claimsChartStartDate') {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.claimsChartStartDate = val1;
        }
      }
      if (name == 'claimsChartEndDate') {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.claimsChartEndDate = val1;
        }
      }
      if( name == 'referralStartDate'){
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.referralStartdate = val1;
        }
      }
      if( name == 'referralEndDate'){
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.referralEnddate = val1;
        }
      }

    }
    if (type == "datechanged") {
      if (name == 'FromDate') {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.AuthStartDate = val1;
          var StartDate = new Date(this.AuthStartDate);
          let setDate = StartDate.setDate(StartDate.getDate() + 90);
          let getDate = setDate;
          this.ValidationDate = this.datepipe.transform(getDate, "MM/dd/yyyy");
          this.clearEndTimeValidation(this.AuthStartDate, this.AuthEndDate, "ComingDueChart");
        }
      }
      if (name == 'EndDate') {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.AuthEndDate = val1;
          this.clearEndTimeValidation(this.AuthStartDate, this.AuthEndDate, "ComingDueChart");
        }
      }
      if (name == 'claimsChartStartDate') {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.claimsChartStartDate = val1;
          var StartDate = new Date(this.claimsChartStartDate);
          let setDate = StartDate.setDate(StartDate.getDate() + 365);
          let getDate = setDate;
          this.ValidationDate = this.datepipe.transform(getDate, "MM/dd/yyyy");
          this.clearEndTimeValidation(this.claimsChartStartDate, this.claimsChartEndDate, "ClaimsChart");
        }
      }
      if (name == 'claimsChartEndDate') {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.claimsChartEndDate = val1;
          this.clearEndTimeValidation(this.claimsChartStartDate, this.claimsChartEndDate, "ClaimsChart");
        }
      }

      if (name == 'claimsChartStartDate') {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.claimsChartStartDate = val1;
          var StartDate = new Date(this.claimsChartStartDate);
          let setDate = StartDate.setDate(StartDate.getDate() + 365);
          let getDate = setDate;
          this.ValidationDate = this.datepipe.transform(getDate, "MM/dd/yyyy");
          this.clearEndTimeValidation(this.claimsChartStartDate, this.claimsChartEndDate, "ClaimsAmountChart");
        }
      }
      if (name == 'claimsChartEndDate') {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.claimsChartEndDate = val1;
          this.clearEndTimeValidation(this.claimsChartStartDate, this.claimsChartEndDate, "ClaimsAmountChart");
        }
      }
      if( name == 'referralStartDate'){
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.referralStartdate = val1;
        }
      }
      if( name == 'referralEndDate'){
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.referralEnddate = val1;
          this.clearEndTimeValidation(this.referralStartdate, this.referralEnddate, "referral");
        }
      }
    }
    if (name == 'FromDate') {
      this.getAuthList.fromDate = this.AuthStartDate;
      this.getAuthList.fromDate = this.global.getDateTimeString(this.AuthStartDate);
    }
    if (name == 'EndDate') {
      this.getAuthList.toDate = this.AuthEndDate;
      this.getAuthList.toDate = this.global.getDateTimeString(this.AuthEndDate);
    }
  }
  clearEndTimeValidation(FromDate, ToDate, ClaimsType) {
    if (FromDate != null && FromDate != undefined && FromDate != '' &&
      ToDate != null && ToDate != undefined && ToDate != '') {
      let EndDate = this.datepipe.transform(ToDate, "MM/dd/yyyy");
      if (new Date(EndDate).getTime() > new Date(this.ValidationDate).getTime()) {


        if (ClaimsType != "ComingDueChart") {
          this.toastrService.error("Date range should not be greater than 1 year");

        }
        if (ClaimsType == "ComingDueChart") {
          this.toastrService.error("Date range should not be greater than 90 days");
          this.AuthEndDate = null;
        }
        if (ClaimsType == "ClaimsChart") {
          this.claimsChartEndDate = null;
        }
        if (ClaimsType == "ClaimsAmountChart") {
          this.claimsChartEndDate = null;
        }
        if(ClaimsType == "referral"){
          this.referralEnddate = null;
          this.toastrService.error("Date range should not be greater than 1 year");
        }
        setTimeout(() => {
          this.toastrService.clear();
        }, 3000);
      }
      if (ToDate != null && ToDate != undefined && ToDate != '') {
        if (new Date(FromDate).getTime() > new Date(ToDate).getTime()) {
          if (ClaimsType == "ComingDueChart") {
            this.AuthEndDate = null;
          }
          if (ClaimsType == "ClaimsChart") {
            this.claimsChartEndDate = null;
          }
          if (ClaimsType == "ClaimsAmountChart") {
            this.claimsChartEndDate = null;
          }
          if(ClaimsType == "referral"){
            this.referralEnddate = null;
          }
          this.toastrService.error("end time should greater than start time");
          setTimeout(() => {
            this.toastrService.clear();
          }, 3000);
          return;
        }
      }

    }
  }
  getExpiringAuthorizationList() {
    let url = "api/ClientAuthorization/getExpiringAuthorizationList";
    console.log(this.RemainUnit)
    if(this.RemainUnit)
    {
       url = "api/ClientAuthorization/getLowRemainingUnitsList";
    }
    this.AuthExpiredList.outputValuesAuth(this.getAuthList,url);
    this.dataAuth.pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.AuthDueList = data.result;
      this.AuthDataList = data.result;
      
      if (data != null && data.result.length > 10) {
        this.gridAuthList.height = '500';
      }
      else {
        this.gridAuthList.height = 'auto';
      }

    },
      (err: HttpErrorResponse) => {
        this.toastrService.error(
          err.error,
          "error",
        );
      })
  }
  //............................................................onSelect............................................
  public onSelect(event) {
    console.log(event);
    let isValue: string = event.label
    this.checkComingDueReport = false;
    if (isValue == "Expired") {
      this.getAuthList.fromDate = "0001-01-01"
      var today = new Date();
      this.previousDate = today.setDate(today.getDate() - 1);
      this.getAuthList.toDate = this.previousDate;
      this.getAuthList.toDate = this.global.getDateTimeString(this.previousDate);

      this.getExpiringAuthorizationList()
      document.getElementById("openComingDueAuth").click();
    }
    else if (isValue == "Expiring within 30 days") {
      var today = new Date();
      this.getAuthList.fromDate = this.currentDate;
      this.Expired30DEndDate = today.setDate(today.getDate() + 29);
      this.getAuthList.toDate = this.Expired30DEndDate;
      this.getAuthList.toDate = this.global.getDateTimeString(this.Expired30DEndDate);

      this.getExpiringAuthorizationList()
      document.getElementById("openComingDueAuth").click();
    }
    else if (isValue == "Expiring within 60 days") {
      var today = new Date();
      this.Expired60DStartDate = new Date(new Date().setDate(today.getDate() + 30));
      this.Expired60DEndDate = new Date(new Date().setDate(today.getDate() + 59));
      this.getAuthList.fromDate = this.global.getDateTimeString(this.Expired60DStartDate);
      this.getAuthList.toDate = this.global.getDateTimeString(this.Expired60DEndDate);

      this.getExpiringAuthorizationList()
      document.getElementById("openComingDueAuth").click();
    }
    else if (isValue == "Expiring within 90 days") {
      var today = new Date();
      this.Expired90DStartDate = new Date(new Date().setDate(today.getDate() + 60));
      this.Expired90DEndDate = new Date(new Date().setDate(today.getDate() + 89));
      this.getAuthList.fromDate = this.global.getDateTimeString(this.Expired90DStartDate);
      this.getAuthList.toDate = this.global.getDateTimeString(this.Expired90DEndDate);

      this.getExpiringAuthorizationList()
      document.getElementById("openComingDueAuth").click();
    }
    else if(isValue == 'Low Units'){
      this.RemainUnit = true;
      this.getAuthList.fromDate = "0001-01-01"
      var today = new Date();
      this.previousDate = today.setDate(today.getDate() - 1);
      this.getAuthList.toDate = this.previousDate;
      this.getAuthList.toDate = this.global.getDateTimeString(this.previousDate);
      this.getExpiringAuthorizationList()
      document.getElementById("openRemainingunit").click();
    }
   
  }
  TimesheeCount(data) {
    this.global.InactiveClientTimesheetsFromDate = this.getInActiveClientBo.start;
    this.global.InactiveClientTimesheetsToDate = this.getInActiveClientBo.end;
    this.global.InactiveClientId = data.clientId;
    this.global.InactiveClientTimesheets = true;
    this.router.navigateByUrl("/timesheets");
    document.getElementById("openInActiveClients").click();

  }  //...................................................................onResizeComingDue......................................
  onResizeComingDue(args) {
    if (this.ColumnAuthArray != undefined && this.ColumnAuthArray != null) {
      const column = this.gridAuthList.getColumnByField(args.column.field);
      column.width = args.column.width;
      this.ColumnAuthArray.forEach(element => {
        if (element.column == column.headerText) {
          element.width = parseInt(column.width.toString());
        }
      });
      // this.SaveColumnwidth();
    }
  }
  //...........................................................dataStateComingDueChange..............................
  public dataStateComingDueChange(state): void {
    this.type = (state.action.requestType).toString();
    if (this.type != "filterchoicerequest") {
      if ((state.sorted || []).length) {
        this.getAuthList.orderColumn = state.sorted[0].name;
        this.getAuthList.orderType = state.sorted[0].direction === 'descending' ? 'DESC' : 'ASC';
      }
    }
    if (this.type == "filtering" && state.action.action != "clearFilter") {
      this.getAuthList.value = state.action.currentFilterObject.value;
      this.getAuthList.field = state.action.currentFilterObject.field;
      this.getAuthList.matchCase = state.action.currentFilterObject.matchCase;
      this.getAuthList.operator = state.action.currentFilterObject.operator;
    }
    else {
      if (this.type == "filtering" && state.action.action == "clearFilter") {
        this.getAuthList.field = "ClientName";
        this.getAuthList.matchCase = false;
        this.getAuthList.operator = "contains";
        this.getAuthList.value = "";
        this.getAuthList.type = "string"
      }
    }
    this.getExpiringAuthorizationList();
  }
  //................................................onActionComingDueComplete.......................................
  public onActionComingDueComplete(args) {
    this.getAuthList.currentpageno = this.gridAuthList.pagerModule.pagerObj.currentPage;
    this.getAuthList.pageitem = this.gridAuthList.pagerModule.pagerObj.pageSize;
    if (args.name == "actionBegin" && args.requestType == "filterbeforeopen") {
      this.getAuthList.type = args.columnType
    }
  }

  public onActionLowUnits(args) {
    this.getAuthList.currentpageno = this.gridUnitList.pagerModule.pagerObj.currentPage;
    this.getAuthList.pageitem = this.gridUnitList.pagerModule.pagerObj.pageSize;
    if (args.name == "actionBegin" && args.requestType == "filterbeforeopen") {
      this.getAuthList.type = args.columnType
    }
  }

  // ............................................excelCurrentPages.......................................................
  excelCurrentPages() {
    this.AuthDueList.forEach(element => {
      element.dob = element.dob != null ? this.datepipe.transform(element.dob, "MM/dd/yyyy") : null;
      element.startDate = element.startDate != null ? this.datepipe.transform(element.startDate, "MM/dd/yyyy") : null;
      element.endDate = element.endDate != null ? this.datepipe.transform(element.endDate, "MM/dd/yyyy") : null;
    });
    const excelExportProperties: ExcelExportProperties = {
      dataSource: this.AuthDueList,
      fileName: 'ComingDueReport' + new Date().toISOString().replace("Z", "") + '.xlsx'
    };
    this.gridAuthList.excelExport(excelExportProperties);
  }
  // ............................................excelAllPages.......................................................
  excelAllPages() {
    this.downloadExcel();
  }
  // ............................................downloadExcel.......................................................
  async downloadExcel() {
    let getBO = JSON.parse(JSON.stringify(this.getAuthList));
    let url = "api/ClientAuthorization/getExpiringAuthorizationListWithoutPagination?";
    this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(getBO, url).pipe(takeUntil(this.onDestroy$)).subscribe((data) => {
      data.result.forEach(element => {
        element.dob = element.dob != null ? this.datepipe.transform(element.dob, "MM/dd/yyyy") : null;
        element.startDate = element.startDate != null ? this.datepipe.transform(element.startDate, "MM/dd/yyyy") : null;
        element.endDate = element.endDate != null ? this.datepipe.transform(element.endDate, "MM/dd/yyyy") : null;
      });
      const excelExportProperties: ExcelExportProperties = {
        dataSource: data.result,
        fileName: 'ComingDueReport' + new Date().toISOString().replace("Z", "") + '.xlsx'
      }
      this.gridAuthList.excelExport(excelExportProperties);
    })
  }
  // ............................................pdfCurrentPages.......................................................
  pdfCurrentPages() {
    let Printdata = this.AuthDueList;
    var a = window.open('', '', 'height=700, width=700');
    a.document.write('<html>')
    a.document.write('<head><meta name="viewport" content="width=device-width, initial-scale=1"> <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css"></head>');
    a.document.write('<body ><table class="table table-hover table-bordered table-responsive" style="margin-top: 5px;margin-left: 10px;border:solid #000 !important; border-width:1px 0 0 1px !important;">');
    a.document.write('<thead>');
    a.document.write('<th style="border:solid #000 !important;border-width:0 1px 1px 0 !important;border-top:1px">Client Name</th>');
    a.document.write('<th  style="border:solid #000 !important;border-width:0 1px 1px 0 !important;">Company Name</th>');
    a.document.write('<th  style="border:solid #000 !important;border-width:0 1px 1px 0 !important;">Dob</th>');
    a.document.write('<th  style="border:solid #000 !important;border-width:0 1px 1px 0 !important;">Service Code</th>');
    a.document.write('<th  style="border:solid #000 !important;border-width:0 1px 1px 0 !important;">Payer Name</th>');
    a.document.write('<th  style="border:solid #000 !important;border-width:0 1px 1px 0 !important;">Start Date</th>');
    a.document.write('<th  style="border:solid #000 !important;border-width:0 1px 1px 0 !important;">End Date</th>');
    a.document.write('<th  style="border:solid #000 !important;border-width:0 1px 1px 0 !important;">Phone Number</th>');
    a.document.write('<th  style="border:solid #000 !important;border-width:0 1px 1px 0 !important;">Location</th>');
    a.document.write('<th  style="border:solid #000 !important;border-width:0 1px 1px 0 !important;">Authorization Number</th>');
    a.document.write('<th  style="border:solid #000 !important;border-width:0 1px 1px 0 !important;">Insurance Number</th>');

    a.document.write('<th  style="border:solid #000 !important;border-width:0 1px 1px 0 !important;">County</th>');
    a.document.write('<th  style="border:solid #000 !important;border-width:0 1px 1px 0 !important;">Medicare</th>');
    a.document.write('<th  style="border:solid #000 !important;border-width:0 1px 1px 0 !important;">Waiver</th>');

    a.document.write('<th  style="border:solid #000 !important;border-width:0 1px 1px 0 !important;">Street</th>');

    a.document.write('<th  style="border:solid #000 !important;border-width:0 1px 1px 0 !important;">ZipCode</th>');
    a.document.write('</thead>');
    a.document.write('<tbody>');
    let count = 0;
    Printdata.forEach(element => {
      count++;
      a.document.write('<tr style="border:solid #000 !important; border-width:1px 0 0 1px !important;">');
      a.document.write(' <td style="text-align: left;font-weight: 600;border:solid #000 !important;border-width:0 1px 1px 0 !important;">' + element.clientName + '</td>');
      a.document.write(' <td style="text-align: left;font-weight: 600;border:solid #000 !important;border-width:0 1px 1px 0 !important;">' + element.companyName + '</td>');
      a.document.write(' <td style="text-align: left;font-weight: 600;border:solid #000 !important;border-width:0 1px 1px 0 !important;">' + new Date(new Date(element.dob) + "Z").toLocaleDateString() + '</td>');
      a.document.write(' <td style="text-align: left;font-weight: 600;border:solid #000 !important;border-width:0 1px 1px 0 !important;">' + element.serviceCode + '</td>');
      a.document.write(' <td style="text-align: left;font-weight: 600;border:solid #000 !important;border-width:0 1px 1px 0 !important;">' + element.payerName + '</td>');
      a.document.write(' <td style="text-align: left;font-weight: 600;border:solid #000 !important;border-width:0 1px 1px 0 !important;">' + new Date(new Date(element.startDate) + "Z").toLocaleDateString() + '</td>');
      a.document.write(' <td style="text-align: left;font-weight: 600;border:solid #000 !important;border-width:0 1px 1px 0 !important;">' + new Date(new Date(element.endDate) + "Z").toLocaleDateString() + '</td>');
      a.document.write(' <td style="text-align: left;font-weight: 600;border:solid #000 !important;border-width:0 1px 1px 0 !important;">' + (element.phone != null ? element.phone : "") + '</td>');
      a.document.write(' <td style="text-align: left;font-weight: 600;border:solid #000 !important;border-width:0 1px 1px 0 !important;">' + (element.location != null ? element.location : "") + '</td>');
      a.document.write(' <td style="text-align: left;font-weight: 600;border:solid #000 !important;border-width:0 1px 1px 0 !important;">' + (element.authorizationNo != null ? element.authorizationNo : "") + '</td>');
      a.document.write(' <td style="text-align: left;font-weight: 600;border:solid #000 !important;border-width:0 1px 1px 0 !important;">' + (element.insuranceNo != null ? element.insuranceNo : "") + '</td>');

      a.document.write(' <td style="text-align: left;font-weight: 600;border:solid #000 !important;border-width:0 1px 1px 0 !important;">' + (element.county != null ? element.county : "") + '</td>');

      a.document.write(' <td style="text-align: left;font-weight: 600;border:solid #000 !important;border-width:0 1px 1px 0 !important;">' + (element.medicare != null ? element.medicare : "") + '</td>');
      a.document.write(' <td style="text-align: left;font-weight: 600;border:solid #000 !important;border-width:0 1px 1px 0 !important;">' + (element.waiver != null ? element.waiver : "") + '</td>');

      a.document.write(' <td style="text-align: left;font-weight: 600;border:solid #000 !important;border-width:0 1px 1px 0 !important;">' + (element.street != null ? element.street : "") + '</td>');
      a.document.write(' <td style="text-align: left;font-weight: 600;border:solid #000 !important;border-width:0 1px 1px 0 !important;">' + (element.zipCode != null ? element.zipCode : "") + '</td>');
      a.document.write('</tr>');
    });
    a.document.write(' </tbody>  </table>');
    a.document.write('</body></html>');
    a.document.close();
    let interval = setInterval(() => {
      if (count == Printdata.length) {
        setTimeout(() => {
          a.print()
        }, 1000);
        clearInterval(interval);
      }
    }, 100)
  }
  ComingDuePowerBiReports() {
    if (this.checkComingDueReport == false) {
      this.GenerateComingDueChartReport();
    }
    else {
      this.GenerateComingDueReport();
    }
  }
  GenerateComingDueReport() {
    let currentTime = this.datepipe.transform(new Date(), "MM/dd/yyyy hh:mm a");
    this.reportcontain = true;
    this.reptitle = "Coming Due Authorization Report";
    this.CommonAPI.CommonFunctionforPowerBiToken().then((token) => {
      document.getElementById("openPowerBiModal").click();
      let embedUrl =
        "https://app.powerbi.com/rdlEmbed?reportId=" +
        this.configuration.ComingDueAuthorizationReportId +
        "&rp:ExecTime=" +
        currentTime +
        "&rp:agencyid=" +
        this.global.globalAgencyId +
        "&rp:locationid=" +
        ((this.locationId != null && this.locationId != undefined && this.locationId!="00000000-0000-0000-0000-000000000000") ? this.locationId : '') +
        "&rp:startdate=" +
        this.datepipe.transform(this.AuthStartDate, "yyy-MM-dd") +
        "&rp:enddate=" +
        this.datepipe.transform(this.AuthEndDate, "yyy-MM-dd") +
        "&filterPaneEnabled=False&rdl:parameterPanel=hidden";
      let embedReportId = this.configuration.ComingDueAuthorizationReportId;
      let config = {
        type: "report",
        tokenType: pbi.models.TokenType.Aad,
        accessToken: token[0],
        embedUrl: embedUrl,
        id: embedReportId,
        settings: {},
        viewmode: pbi.models.ViewMode.View,
      };
      let reportContainer = this.reportContainer.nativeElement;
      let powerbi = new pbi.service.Service(
        pbi.factories.hpmFactory,
        pbi.factories.wpmpFactory,
        pbi.factories.routerFactory
      );
      let report = powerbi.embed(reportContainer, config);
      report.off("loaded");
      report.on("loaded", () => { });
    });
  }
  GenerateComingDueChartReport() {
    let currentTime = this.datepipe.transform(new Date(), "MM/dd/yyyy hh:mm a");
    this.reportcontain = true;
    if(this.RemainUnit){
      this.reptitle = "Low Units";
    }
    else{
      this.reptitle = "Coming Due Authorization Chart";
    }
    this.CommonAPI.CommonFunctionforPowerBiToken().then((token) => {
      document.getElementById("openPowerBiModal").click();
      let embedUrl =
        "https://app.powerbi.com/rdlEmbed?reportId=" +
        this.configuration.ComingDueAuthorizationChartReportId +
        "&rp:ExecTime=" +
        currentTime +
        "&rp:agencyid=" +
        this.global.globalAgencyId +
        "&rp:locationid=" +
        ((this.locationId != null && this.locationId != undefined && this.locationId!="00000000-0000-0000-0000-000000000000") ? this.locationId : '') +
        "&rp:islowunits="+
        this.RemainUnit+
        "&rp:startdate=" +
        this.datepipe.transform(this.getAuthList.fromDate, "yyy-MM-dd") +
        "&rp:enddate=" +
        this.datepipe.transform(this.getAuthList.toDate, "yyy-MM-dd") +
        "&filterPaneEnabled=False&rdl:parameterPanel=hidden";
      let embedReportId = this.configuration.ComingDueAuthorizationChartReportId;
      let config = {
        type: "report",
        tokenType: pbi.models.TokenType.Aad,
        accessToken: token[0],
        embedUrl: embedUrl,
        id: embedReportId,
        settings: {},
        viewmode: pbi.models.ViewMode.View,
      };

      let reportContainer = this.reportContainer.nativeElement;
      let powerbi = new pbi.service.Service(
        pbi.factories.hpmFactory,
        pbi.factories.wpmpFactory,
        pbi.factories.routerFactory
      );
      let report = powerbi.embed(reportContainer, config);
      report.off("loaded");
      report.on("loaded", () => { });
    });
  }
  // ............................................pdfAllPages.......................................................
  pdfAllPages() {
    let url = "api/ClientAuthorization/getExpiringAuthorizationListWithoutPagination?";
    this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(this.getAuthList, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      let Printdata = data.result;

      var a = window.open('', '', 'height=700, width=700');
      a.document.write('<html>')
      a.document.write('<head><meta name="viewport" content="width=device-width, initial-scale=1"> <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css"></head>');
      a.document.write('<body ><table class="table table-hover table-bordered table-responsive" style="margin-top: 5px;margin-left: 10px;border:solid #000 !important; border-width:1px 0 0 1px !important;">');
      a.document.write('<thead>');
      a.document.write('<th style="border:solid #000 !important;border-width:0 1px 1px 0 !important;border-top:1px">Client Name</th>');
      a.document.write('<th  style="border:solid #000 !important;border-width:0 1px 1px 0 !important;">Company Name</th>');
      a.document.write('<th  style="border:solid #000 !important;border-width:0 1px 1px 0 !important;">Dob</th>');
      a.document.write('<th  style="border:solid #000 !important;border-width:0 1px 1px 0 !important;">Service Code</th>');
      a.document.write('<th  style="border:solid #000 !important;border-width:0 1px 1px 0 !important;">Payer Name</th>');
      a.document.write('<th  style="border:solid #000 !important;border-width:0 1px 1px 0 !important;">Start Date</th>');
      a.document.write('<th  style="border:solid #000 !important;border-width:0 1px 1px 0 !important;">End Date</th>');
      a.document.write('<th  style="border:solid #000 !important;border-width:0 1px 1px 0 !important;">Phone Number</th>');
      a.document.write('<th  style="border:solid #000 !important;border-width:0 1px 1px 0 !important;">Location</th>');
      a.document.write('<th  style="border:solid #000 !important;border-width:0 1px 1px 0 !important;">Authorization Number</th>');
      a.document.write('<th  style="border:solid #000 !important;border-width:0 1px 1px 0 !important;">Insurance Number</th>');
      a.document.write('<th  style="border:solid #000 !important;border-width:0 1px 1px 0 !important;">County</th>');
      a.document.write('<th  style="border:solid #000 !important;border-width:0 1px 1px 0 !important;">Medicare</th>');
      a.document.write('<th  style="border:solid #000 !important;border-width:0 1px 1px 0 !important;">Waiver</th>');
      a.document.write('<th  style="border:solid #000 !important;border-width:0 1px 1px 0 !important;">Street</th>');

      a.document.write('<th  style="border:solid #000 !important;border-width:0 1px 1px 0 !important;">ZipCode</th>');
      a.document.write('</thead>');
      a.document.write('<tbody>');
      let count = 0;
      Printdata.forEach(element => {
        count++;
        a.document.write('<tr style="border:solid #000 !important; border-width:1px 0 0 1px !important;">');
        a.document.write(' <td style="text-align: left;font-weight: 600;border:solid #000 !important;border-width:0 1px 1px 0 !important;">' + element.clientName + '</td>');
        a.document.write(' <td style="text-align: left;font-weight: 600;border:solid #000 !important;border-width:0 1px 1px 0 !important;">' + element.companyName + '</td>');
        a.document.write(' <td style="text-align: left;font-weight: 600;border:solid #000 !important;border-width:0 1px 1px 0 !important;">' + new Date(new Date(element.dob) + "Z").toLocaleDateString() + '</td>');
        a.document.write(' <td style="text-align: left;font-weight: 600;border:solid #000 !important;border-width:0 1px 1px 0 !important;">' + element.serviceCode + '</td>');
        a.document.write(' <td style="text-align: left;font-weight: 600;border:solid #000 !important;border-width:0 1px 1px 0 !important;">' + (element.payerName != null ? element.payerName : "") + '</td>');
        a.document.write(' <td style="text-align: left;font-weight: 600;border:solid #000 !important;border-width:0 1px 1px 0 !important;">' + new Date(new Date(element.startDate) + "Z").toLocaleDateString() + '</td>');
        a.document.write(' <td style="text-align: left;font-weight: 600;border:solid #000 !important;border-width:0 1px 1px 0 !important;">' + new Date(new Date(element.endDate) + "Z").toLocaleDateString() + '</td>');
        a.document.write(' <td style="text-align: left;font-weight: 600;border:solid #000 !important;border-width:0 1px 1px 0 !important;">' + (element.phone != null ? element.phone : '') + '</td>');
        a.document.write(' <td style="text-align: left;font-weight: 600;border:solid #000 !important;border-width:0 1px 1px 0 !important;">' + (element.location != null ? element.location : "") + '</td>');
        a.document.write(' <td style="text-align: left;font-weight: 600;border:solid #000 !important;border-width:0 1px 1px 0 !important;">' + (element.authorizationNo != null ? element.authorizationNo : "") + '</td>');
        a.document.write(' <td style="text-align: left;font-weight: 600;border:solid #000 !important;border-width:0 1px 1px 0 !important;">' + (element.insuranceNo != null ? element.insuranceNo : "") + '</td>');

        a.document.write(' <td style="text-align: left;font-weight: 600;border:solid #000 !important;border-width:0 1px 1px 0 !important;">' + (element.county != null ? element.county : "") + '</td>');

        a.document.write(' <td style="text-align: left;font-weight: 600;border:solid #000 !important;border-width:0 1px 1px 0 !important;">' + (element.medicare != null ? element.medicare : "") + '</td>');
        a.document.write(' <td style="text-align: left;font-weight: 600;border:solid #000 !important;border-width:0 1px 1px 0 !important;">' + (element.waiver != null ? element.waiver : "") + '</td>');
        a.document.write(' <td style="text-align: left;font-weight: 600;border:solid #000 !important;border-width:0 1px 1px 0 !important;">' + (element.street != null ? element.street : "") + '</td>');
        a.document.write(' <td style="text-align: left;font-weight: 600;border:solid #000 !important;border-width:0 1px 1px 0 !important;">' + (element.zipCode != null ? element.zipCode : "") + '</td>');
        a.document.write('</tr>');
        a.document.write('</tr>');
      });
      a.document.write(' </tbody>  </table>');
      a.document.write('</body></html>');
      a.document.close();
      let interval = setInterval(() => {
        if (count == Printdata.length) {
          setTimeout(() => {
            a.print()
          }, 1000);
          clearInterval(interval);
        }
      }, 100)
    },
      (err: HttpErrorResponse) => {
        this.toastrService.error(err.message, 'error')
      });
  }
  // ............................................gridClear.......................................................
  gridClear() {
    this.getAuthList.currentpageno = this.gridAuthList.pagerModule.pagerObj.currentPage;
    this.getAuthList.pageitem = this.gridAuthList.pagerModule.pagerObj.pageSize;
    this.getAuthList.orderColumn = "clientName";
    this.getAuthList.orderType = "asc";
    this.getAuthList.field = "clientName";
    this.getAuthList.value = "";
    this.getAuthList.operator = "contains";
    this.getAuthList.matchCase = false;
    this.gridAuthList.pageSettings.currentPage = 1;
    this.gridAuthList.clearFiltering();
    this.gridAuthList.clearSorting();
  }
  // ........................................gridInactiveClientClear.............................................
  gridInactiveClientClear() {
    this.getInActiveClientBo.currentpageno = this.gridInactiveClientList.pagerModule.pagerObj.currentPage;
    this.getInActiveClientBo.pageitem = this.gridInactiveClientList.pagerModule.pagerObj.pageSize;
    this.getInActiveClientBo.orderColumn = "clientName";
    this.getInActiveClientBo.orderType = "asc";
    this.getInActiveClientBo.field = "clientName";
    this.getInActiveClientBo.value = "";
    this.getInActiveClientBo.operator = "contains";
    this.getInActiveClientBo.matchCase = false;
    this.gridInactiveClientList.pageSettings.currentPage = 1;
    this.gridInactiveClientList.clearFiltering();
    this.gridInactiveClientList.clearSorting();
  }
  //...............................exportAsExcelClient.....................................................
  exportAsExcelClient() {
    this.downloadExcelClientAuth();
  }
  //...............................downloadExcelClientAuth.....................................................
  async downloadExcelClientAuth() {
    this.filters.locationLid = (this.global.globalLocationId != null && this.global.globalLocationId != undefined) ? this.global.globalLocationId : "00000000-0000-0000-0000-000000000000"
    let getBO = JSON.parse(JSON.stringify(this.filters));
    getBO.dateFilterType = this.DashboardChartFilterType;
    let url = this.global.reporttype == "Expired" ? "api/Client/downloadClientExcelOptimizedForDashboard" : "api/client/getExcelReportForExceedAndUnderAuthorization";
    this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(getBO, url).pipe(takeUntil(this.onDestroy$)).subscribe((data) => {
      const blob = this.b64toBlob(data.fileString, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
      const blobUrl = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = blobUrl;
      a.download = data.fileName;
      a.click();
    })
  }
   //...............................exportAsExcelReferral.....................................................
   exportAsExcelReferral() {
    this.downloadExcelReferral();
  }
  //...............................downloadExcel.....................................................
  async downloadExcelReferral() {
    let getBO = JSON.parse(JSON.stringify(this.referralexport));
    getBO.startDate = this.global.getDateTimeString(this.referralStartdate);
    getBO.endDate = this.global.getDateTimeString(this.referralEnddate);
    if(this.referralAge == 'true')
    {
      getBO.isOver = true;
    }
    else
    getBO.isOver = false;
    getBO.referralStatus = this.referralevent;
    let url = "api/Referral/downloadReferrals"
    this.CommonAPI.saveorUpdateFunctionFileSaver(getBO, url, this.referralevent);
  }
  // ..........................................b64toBlob..........................................
  b64toBlob = (b64Data, contentType = '', sliceSize = 512) => {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }
  //..........................................getHousingContactTypes................................................
  getHousingContactTypes() {
    let url = "api/LOV/getLovDropDown?"
    let params = new URLSearchParams();
    params.append("Code", "HOUSINGSTABILIZATIONCONTACTTYPE");
    this.CommonAPI.getDropDownList('HOUSINGSTABILIZATIONCONTACTTYPE', params, url, "LovDropDown").then((data: any) => {
      this.global.contactTypes = data;
    })
  }
  //..........................................onSelectHousingStabilization................................................
  public onSelectHousingStabilization(event) {
    if (event.name == 'Direct') {
      this.global.contactHouseCaseTypelid = this.global.contactTypes?.filter(st => st.Value == "Direct(face to face)")[0]?.Key;
    }
    else if (event.name == 'Indirect') {
      this.global.contactHouseCaseTypelid = this.global.contactTypes?.filter(st => st.Value == "Indirect")[0]?.Key;
    }
    else if (event.name == 'Remote') {
      this.global.contactHouseCaseTypelid = this.global.contactTypes?.filter(st => st.Value.startsWith("Remote Direct") )[0]?.Key;
    }
    this.router.navigateByUrl("/housingstabilization");
  }
  //....................................GetHousingCaseNoteDashboardDetails..................................................
  public GetHousingCaseNoteDashboardDetails() {
    let url = "api/HousingCaseNote/getAgencyDashboardHousingHoursBasedOnContactType?";
    this.CommonAPI.GetFunctionwithResponseTypeJson("", url).pipe(takeUntil(this.onDestroy$)).subscribe((res: any) => {
      if (res != null) {
        this.HouseStabilizationChart = [
          {
            name: 'Direct',
            value: Math.floor(Number(res.direct))
          },
          {
            name: 'Indirect',
            value: Math.floor(Number(res.indirect))
          },
          {
            name: 'Remote',
            value: Math.floor(Number(res.remotedirect))
          }
        ];
      }
    },
      (err: HttpErrorResponse) => {
        if (err) {
        }
      })
  }
  //.......................................................getDashboardHours................................................
  getDashboardHours() {
    let url = "api/Timesheet/GetDashboardHours?";
    this.CommonAPI.GetFunctionwithResponseTypeJson("", url).pipe(takeUntil(this.onDestroy$)).subscribe((data) => {
      if (data.exceededCount == 0 && data.underCount == 0) {
        this.viewHoursChartList = false;
      }
      else {
        this.viewHoursChartList = true;
        this.DashboardHoursChart = [
          {
            name: 'Under',
            value: Math.floor(Number(data.underCount))
          },
          {
            name: 'Exceeded',
            value: Math.floor(Number(data.exceededCount))
          },

        ];
      }
    })
  }
  // ...............................getHoursList..............................
  getHoursList(event) {
    this.Hourslabel = event.label;
    let pageHours = JSON.parse(this.global.globalColumn.column)[0].Dashboard_Hours.Pagesize;
    this.initialPageHours = { currentPage: 1, totalRecordsCount: 0, pageCount: pageHours, pageSize: pageHours, pageSizes: this.pageSizes };
    this.GetDashboardHoursFilter.pageitems = pageHours;
    if (event.label == "Exceeded") {
      this.GetDashboardHoursDetailsExceeded();
      document.getElementById("openDashboardHours").click();
    }
    else if (event.label == "Under") {
      this.GetDashboardHoursDetailsUnder();
      document.getElementById("openDashboardHours").click();
    }
  }
  // ...............................GetDashboardHoursDetailsExceeded..............................
  GetDashboardHoursDetailsExceeded() {
    this.GetDashboardHoursFilter.locationLid = this.locationId;
    this.UEService.executeExceeded(this.GetDashboardHoursFilter);
    this.DashboardHoursList.pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.HoursData = data.result;
      if (data != null && data.result.length > 15) {
        this.gridHoursList.height = '500';
      }
      else {
        this.gridHoursList.height = 'auto';
      }
    })
  }
  // ...............................GetDashboardHoursDetailsUnder..............................
  GetDashboardHoursDetailsUnder() {
    this.GetDashboardHoursFilter.locationLid = this.locationId;
    this.UEService.outputValuesUnder(this.GetDashboardHoursFilter);
    this.DashboardHoursList.pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.HoursData = data.result
      if (data != null && data.result.length > 15) {
        this.gridHoursList.height = '500';
      }
      else {
        this.gridHoursList.height = 'auto';
      }
    })
  }
  // ...............................dataStateHoursChange..............................
  public dataStateHoursChange(state): void {
    this.type = (state.action.requestType).toString();
    if (this.type != "filterchoicerequest") {
      if ((state.sorted || []).length) {
        this.GetDashboardHoursFilter.orderColumn = state.sorted[0].name;
        this.GetDashboardHoursFilter.orderType = state.sorted[0].direction === 'descending' ? 'DESC' : 'ASC';
      }
    }
    if (this.type == "filtering" && state.action.action != "clearFilter") {
      this.GetDashboardHoursFilter.value = state.action.currentFilterObject.value;
      this.GetDashboardHoursFilter.field = state.action.currentFilterObject.field;
      this.GetDashboardHoursFilter.matchCase = state.action.currentFilterObject.matchCase;
      this.GetDashboardHoursFilter.operator = state.action.currentFilterObject.operator;
    }
    else {
      if (this.type == "filtering" && state.action.action == "clearFilter") {
        this.GetDashboardHoursFilter.field = "employeeName";
        this.GetDashboardHoursFilter.matchCase = false;
        this.GetDashboardHoursFilter.operator = "contains";
        this.GetDashboardHoursFilter.value = "";
        this.GetDashboardHoursFilter.type = "string"
      }
      if (this.type == "paging" && state.action.name == "actionBegin") {
        if (this.arraycol.length != 0) {
          if (this.arraycol[0].Dashboard_Hours.Pagesize != state.take) {
            this.arraycol[0].Dashboard_Hours.Pagesize = state.take
            // this.SaveColumnwidth();
          }
        }
      }
    }
    if (this.Hourslabel == "Exceeded") {
      this.GetDashboardHoursDetailsExceeded();
    }
    else if (this.Hourslabel == "Under") {
      this.GetDashboardHoursDetailsUnder();
    }
  }
  // ...............................clearHoursGrid..............................
  clearHoursGrid() {
    this.GetDashboardHoursFilter = new GetDashboardHoursDetailsBO();
    this.gridHoursList.clearFiltering();
    this.gridHoursList.clearSorting();
  }
  //................................................onActionComingDueComplete.......................................
  public onActionHoursComplete(args) {
    this.GetDashboardHoursFilter.currentpage = this.gridHoursList.pagerModule.pagerObj.currentPage;
    this.GetDashboardHoursFilter.pageitems = this.gridHoursList.pagerModule.pagerObj.pageSize;
    if (args.name == "actionBegin" && args.requestType == "filterbeforeopen") {
      this.GetDashboardHoursFilter.type = args.columnType
    }
  }
  //................................................downloadExcelforDashboardHours.......................................
  async downloadExcelforDashboardHours() {
    const excelExportProperties: ExcelExportProperties = {
      dataSource: this.HoursData,
      fileName: 'HoursReport' + new Date().toISOString().replace("Z", "") + '.xlsx'
    }
    this.gridHoursList.excelExport(excelExportProperties);
  }
  ExpandAll() {
    this.expandorCollapseall = true;
    this.CollapseBo = new CollapseBo();
    // this.getUMPI();
    this.getAuthCount();
    // this.GetHousingCaseNoteDashboardDetails();
    this.getExpiringAuthorizationCount();
    // this.getDashboardHours();
    this.getClientzipcodeFilter();
    let now = new Date();
    let claimsChartStartDate = new Date(now.setMonth(0, 1));
    this.claimsChartStartDate = this.datepipe.transform(claimsChartStartDate, "MM/dd/yyyy");
    this.claimsChartEndDate = (new Date().getMonth() + 1) + '/' + new Date().getDate() + '/' + new Date().getFullYear();
    this.DashboardChartFilterType = "CURRENTDATE";
    this.filters.clientstatus = "Expired SA";
    this.ExceedChartDateType="EXCEEDCURRENTDATE";
    this.referralAge = 'false';
    this.getclientcount();
    this.claimsChartFilter();
    this.ShowExceedAuthLineChart();

    this.GetEventsList();
  }
  CollapesAll() {
    this.expandorCollapseall = false;
    this.collapseCard();
  }
  collapseCard() {
    this.CollapseBo.EXPBOOL = true;
    this.CollapseBo.EXPBOOL1 = true;
    this.CollapseBo.EXPBOOL2 = true;
    this.CollapseBo.EXPBOOL3 = true;
    this.CollapseBo.EXPBOOL4 = true;
    this.CollapseBo.EXPBOOL5 = true;
    this.CollapseBo.ComingDueBool = true;
    this.CollapseBo.Excludedbool = true;
    this.CollapseBo.viewHousingorHoursChart = true;
    this.CollapseBo.ClientcountperZipcodeList = true;
    this.CollapseBo.EXPBOOLEXCEED = true;
  }
  checkExpandorNot() {
    if (this.CollapseBo.EXPBOOL == false && this.CollapseBo.EXPBOOL1 == false &&
      this.CollapseBo.EXPBOOL2 == false && this.CollapseBo.EXPBOOL3 == false &&
      this.CollapseBo.EXPBOOL4 == false && this.CollapseBo.EXPBOOL5 == false &&
      this.CollapseBo.Excludedbool == false && this.CollapseBo.viewHousingorHoursChart == false
      && this.CollapseBo.ClientcountperZipcodeList == false && this.CollapseBo.EXPBOOLEXCEED ==false) {
      this.expandorCollapseall = true;
    }
    else {
      this.expandorCollapseall = false;
    }
  }
  //.......................................................getDashboardHours................................................
  downloadClientzipcodeCountExcel() {
    let params = new URLSearchParams();
    params.append("agencyId", this.global.globalAgencyId);
    let url = "api/Client/downloadClientzipcodeCountExcel?";
    this.CommonAPI.GetFunctionwithResponseTypeJson(params, url).pipe(takeUntil(this.onDestroy$)).subscribe((data) => {
      const blob = this.b64toBlob(data.fileString, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
      const blobUrl = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = blobUrl;
      a.download = data.fileName;
      a.click();
    })
  }
  expandClientZipCodeHours() {
    if (this.CollapseBo.ClientcountperZipcodeList == false) {
      this.CollapseBo.ClientcountperZipcodeList = true;
    } else if (this.CollapseBo.ClientcountperZipcodeList == true) {
      this.initialPageforZipCode = { currentPage: 1, totalRecordsCount: 0, pageCount: this.ClientZipCodeFilter.pageitem, pageSize: this.ClientZipCodeFilter.pageitem, pageSizes: this.pageSizes };
      this.CollapseBo.ClientcountperZipcodeList = false;
      this.getClientzipcodeFilter();
      this.AuthStartDate = null;
      this.AuthEndDate = null;
    }
  }
  getClientzipcodeFilter() {
    this.ClientZipCodeFilter.agencyId = this.global.globalAgencyId
    this.ClientZipCodeFilter.locationLid = this.locationId;
    this.ZPService.outputValuesClientzipcode(this.ClientZipCodeFilter);
    this.ClientZipCodeList.pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.ClientZipCodeData = data.result;
      if (data != null && data.result.length > 10) {
        this.gridClientZipCode.height = '500';
      }
      else {
        this.gridClientZipCode.height = 'auto';
      }
    })
  }
  //............................................ getClientZipCodeDetails............................................
  getClientZipCodeDetails() {
    let params = new URLSearchParams();
    params.append("agencyId", this.global.globalAgencyId);
    let url = "api/Client/getClientzipcodeCount?";
    this.CommonAPI.GetFunctionwithResponseTypeJson(params, url).pipe(takeUntil(this.onDestroy$)).subscribe((data) => {
      this.ClientZipCodeDetailsList = data;
      this.ClientZipCodeDetailsList.forEach(element => {
        if (element.zipcode == null || element.zipcode == undefined || element.zipcode == '') {
          element.name = "No Zip Code";
          element.value = element.count;
          element.zipcode = "No Zip Code";
        }
        else {
          element.name = element.zipcode;
          element.value = element.count;
        }
      })

    })
  }
  //...........................................................dataStateComingDueChange..............................
  public dataStateClientZipCode(state): void {
    this.type = (state.action.requestType).toString();
    if (this.type != "filterchoicerequest") {
      if ((state.sorted || []).length) {
        this.ClientZipCodeFilter.orderColumn = state.sorted[0].name;
        this.ClientZipCodeFilter.orderType = state.sorted[0].direction === 'descending' ? 'DESC' : 'ASC';
      }
    }
    if (this.type == "filtering" && state.action.action != "clearFilter") {
      this.ClientZipCodeFilter.value = state.action.currentFilterObject.value;
      this.ClientZipCodeFilter.field = state.action.currentFilterObject.field;
      this.ClientZipCodeFilter.matchCase = state.action.currentFilterObject.matchCase;
      this.ClientZipCodeFilter.operator = state.action.currentFilterObject.operator;
    }
    else {
      if (this.type == "filtering" && state.action.action == "clearFilter") {
        this.ClientZipCodeFilter.field = "zipcode";
        this.ClientZipCodeFilter.matchCase = false;
        this.ClientZipCodeFilter.operator = "contains";
        this.ClientZipCodeFilter.value = "";
        this.ClientZipCodeFilter.type = "string"
      }
    }
    this.getClientzipcodeFilter();
  }
  //................................................onActionComingDueComplete.......................................
  public onActionClientZipCode(args) {
    this.ClientZipCodeFilter.currentpage = this.gridClientZipCode.pagerModule.pagerObj.currentPage;
    this.ClientZipCodeFilter.pageitem = this.gridClientZipCode.pagerModule.pagerObj.pageSize;
    if (args.name == "actionBegin" && args.requestType == "filterbeforeopen") {
      this.ClientZipCodeFilter.type = args.columnType;
    }
  }
  switchchangeClaimChart() {
    this.getActive837PClaimDashboard();
    this.getActive837IClaimDashboard();
  }
  switchchangeforFromorPrepareDateClaimChart() {
    this.getActive837PClaimDashboard();
    this.getActive837IClaimDashboard();
    if (this.is30DaysOlderClaimChart == false) {
      this.getArchive837PClaimDashboard();
      this.getArchive837IClaimDashboard();
    }
  }
  minusto30days() {
    if (this.is30DaysOlderClaimChart == true) {
      let toDate: any;
      toDate = new Date(new Date().setDate(new Date().getDate() - 30));
      this.claimdata.toDate = this.global.getDateTimeString(toDate);

    }
  }
  // getServiceTypes() {
  //   let url = "api/LOV/getLovDropDown?"
  //   let params = new URLSearchParams();
  //   params.append("ListCode", "SERVICETYPE");
  //   this.CommonAPI.getDropDownList('SERVICETYPE', params, url, "LovDropDown").then((data: any) => {
  //     this.global.serviceType = data;
  //   })
  // }
  ExportAllPendingUmpiEmployee() {
    let url = "api/Employee/Getpendingumpifiltercsv";
    this.CommonAPI.saveorUpdateFunctionFileSaver(this.report, url, "PendingUMPIEmployeeList.csv")
    document.getElementById('exportascsv').click();
  }
  ExportCurrentPageUmpiEmployee() {
    let url = "api/Employee/Getpendingumpifiltercsv";
    this.CommonAPI.saveorUpdateFunctionFileSaver(this.report, url, "PendingUMPIEmployeeList.csv")
    document.getElementById('exportascsv').click();
  }
  printUMPIEmployee() {
    let url = "api/Employee/Getpendingumpifilterprint";
    this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(this.report, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      let Printdata = data;
      var a = window.open('', '', 'height=700, width=700');
      a.document.write('<html>')
      a.document.write('<head><meta name="viewport" content="width=device-width, initial-scale=1"> <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css"></head>');
      a.document.write('<body ><table class="table table-hover table-bordered table-responsive" style="margin-top: 5px;margin-left: 10px;border:solid #000 !important; border-width:1px 0 0 1px !important;">');
      a.document.write('<thead>');
      a.document.write('<th style="border:solid #000 !important;border-width:0 1px 1px 0 !important;border-top:1px">Employee</th>');
      a.document.write('<th  style="border:solid #000 !important;border-width:0 1px 1px 0 !important;">Month</th>');
      a.document.write('<th  style="border:solid #000 !important;border-width:0 1px 1px 0 !important;">Exceeded Hrs</th>');
      a.document.write('<th  style="border:solid #000 !important;border-width:0 1px 1px 0 !important;">Total Hrs</th>');
      a.document.write('<th  style="border:solid #000 !important;border-width:0 1px 1px 0 !important;">Email</th>');
      a.document.write('<th  style="border:solid #000 !important;border-width:0 1px 1px 0 !important;">Phone</th>');
      a.document.write('</thead>');
      a.document.write('<tbody>');
      let count = 0;
      Printdata.forEach(element => {
        count++;
        a.document.write('<tr style="border:solid #000 !important; border-width:1px 0 0 1px !important;">');
        a.document.write(' <td style="text-align: left;font-weight: 600;border:solid #000 !important;border-width:0 1px 1px 0 !important;">' + (element.name == null ? "" : element.name) + '</td>');
        a.document.write(' <td style="text-align: left;font-weight: 600;border:solid #000 !important;border-width:0 1px 1px 0 !important;">' + (element.month == null ? "" : element.month) + '</td>');
        a.document.write(' <td style="text-align: left;font-weight: 600;border:solid #000 !important;border-width:0 1px 1px 0 !important;">' + (element.exceededHours == null ? "" : element.exceededHours) + '</td>');
        a.document.write(' <td style="text-align: left;font-weight: 600;border:solid #000 !important;border-width:0 1px 1px 0 !important;">' + (element.totalhours == null ? "" : element.totalhours) + '</td>');
        a.document.write(' <td style="text-align: left;font-weight: 600;border:solid #000 !important;border-width:0 1px 1px 0 !important;">' + (element.email == null ? "" : element.email) + '</td>');
        a.document.write(' <td style="text-align: left;font-weight: 600;border:solid #000 !important;border-width:0 1px 1px 0 !important;">' + (element.phone == null ? "" : element.phone) + '</td>');
        a.document.write('</tr>');
      });
      a.document.write(' </tbody>  </table>');
      a.document.write('</body></html>');
      a.document.close();
      let interval = setInterval(() => {
        if (count == Printdata.length) {
          setTimeout(() => {
            a.print()
          }, 1000);
          clearInterval(interval);
        }
      }, 100)
    },
      (err: HttpErrorResponse) => {
        this.toastrService.error(err.message, 'error')
      });
  }

// Embeded Powerbi report uk
embedExceedChartPowerBiReport(reportId: string, groupid : string, filterTable: string, filterColumn: string, filterValue: any): void {
  this.CommonAPI.CommonFunctionforPowerBiToken().then(
    (token) => {
      const embedUrl = "https://app.powerbi.com/reportEmbed?reportId=${reportId}&groupId=${groupid}";

      const configurationData: pbi.IEmbedConfiguration = {
        type: 'report',
        tokenType: pbi.models.TokenType.Aad,
        accessToken: token.toString(),
        embedUrl: embedUrl,
        id: reportId,
        settings: {
          filterPaneEnabled: false,
          navContentPaneEnabled: true
        },
      };

      configurationData.filters = [
        {
          $schema: 'http://powerbi.com/product/schema#basicFilter',
          target: {
            table: filterTable,
            column: filterColumn
          },
          operator: 'eq',
          values: [filterValue]
        }
      ] as unknown as pbi.models.IFilter[];

      const reportContainer = this.exceedReportContainer.nativeElement;
      const powerbi = new pbi.service.Service(
        pbi.factories.hpmFactory,
        pbi.factories.wpmpFactory,
        pbi.factories.routerFactory
      );

      const report = powerbi.embed(reportContainer, configurationData);
      report.off('loaded');
      report.on('loaded', () => { });
    },
    (err: HttpErrorResponse) => { }
  );
}
 
ShowExceedAuthLineChart() {
  this.openexceedchart=true
  let reportId = ( (this.ExceedChartDateType == "EXCEEDCURRENTDATE") ? this.configuration.ExceedAuthChartReportid : this.configuration.ExceedAuthChartLastServiceDateReportid);
  this.embedExceedChartPowerBiReport(
    reportId,
    this.configuration.DevReportGroupId,
    'ExceedChart',
    'agency',
    this.global.globalAgencyId
  );
}
getExceedDateType(){
this.openexceedchart=false
setTimeout(() => {
this.ShowExceedAuthLineChart();
  },500)
}
ExceedDateType(datetype){
  this.ExceedChartDateType= datetype
  this.getExceedDateType();
}
public getclientcount() {
  const url = "api/Referral/ReferralDashboard";
  const referralAge = this.referralAge ; 
  
  const params = new URLSearchParams();
  params.append("isOver", referralAge); 
  if(referralAge =='true')
  {
    params.append("startDate",this.referralStartdate);
    params.append("endDate",this.referralEnddate);
  }
  else{
    var today = new Date();
    params.append("startDate",this.global.getDateTimeString(today.setDate(today.getDate() - 1)));
    params.append('endDate',this.currentDate);
  }
  
  this.http.get(`${url}?${params.toString()}`)
    .pipe(takeUntil(this.onDestroy$))
    .subscribe(
      (data: any) => {
        if (data != null) {
          this.referral = [
            {
              name: 'Pending',
              value: Math.floor(Number(data.pending_Count))
            },
            {
              name: 'Onboarded',
              value: Math.floor(Number(data.onboarded_Count))
            },
            {
              name: 'Rejected',
              value: Math.floor(Number(data.rejected_Count))
            }
          ];
        }
      },
      (err: HttpErrorResponse) => {
        if (err) {
          console.error('Error fetching client count:', err.message);
        }
      }
    );
}

public ngOnDestroy(): void {
  this.onDestroy$.next();
}


// public events: any = [
//   { id: 1, title: 'Meeting with Team', description: 'Discuss Q1 plans.', date: new Date('2025-01-12'), time: '10:00 AM' },
//   { id: 2, title: 'Project Launch', description: 'Launching new project.', date: new Date('2025-01-15'), time: '2:00 PM' },
// ];
events:any=[]
itemsPerPage: number = 9; // Number of items per page
ListSendBO:GetEventListBo = new GetEventListBo();
totalCount:number;
onPageChange(page: number): void {
  this.currentPage = page;
  this.ListSendBO.currentpageno = this.currentPage;
  this.GetEventsList(); // Call the API for the new page
}
 GetEventsList() {
    let url = "api/Event/GetUpcomingEvent?"
    let responseData =
    {
      result: "result",
      count: "count",
    }
    this.ListSendBO.orderColumn="ClientName"
    this.ListSendBO.orderType="asc"
    this.ListSendBO.field="ClientName"
    this.ListSendBO.value=""

    this.CommonAPI.outputValues(url,this.ListSendBO,responseData,"")
    let count = 0;
    this.dataevents.pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
     console.log(data,"data====================");
      
      this.events = data.result;
      this.totalCount= data.count;

      console.log(this.events,"events===");
      
     // this.events = data.result;
      count = count + 1
      if (data != null && data != undefined && count == 1) {
        if (this.global.globalAgencyId != '00000000-0000-0000-0000-000000000000') {
          // this.getColumnwidth();
        }
      }
   
     
    })
  }
}